var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcTotaluser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 41,
    viewBox: "0 0 47 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 0H5C2.23858 0 0 2.23858 0 5V27C0 29.7614 2.23858 32 5 32H27C29.7614 32 32 29.7614 32 27V5C32 2.23858 29.7614 0 27 0Z",
    fill: "#03F5AE",
    fillOpacity: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 9H20C17.2386 9 15 11.2386 15 14V36C15 38.7614 17.2386 41 20 41H42C44.7614 41 47 38.7614 47 36V14C47 11.2386 44.7614 9 42 9Z",
    fill: "#AC6AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 32V14C15 12.6739 15.5272 11.4022 16.4648 10.4645C17.4025 9.5268 18.6739 9 20 9H32V27C32 28.3261 31.4728 29.5978 30.5352 30.5355C29.5975 31.4732 28.3261 32 27 32H15Z",
    fill: "#72F5FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_36_286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.499 20.072C11.522 20.0712 12.5028 19.6645 13.2261 18.9412C13.9495 18.2178 14.3562 17.237 14.357 16.214C14.3559 15.1912 13.9491 14.2107 13.2258 13.4875C12.5025 12.7644 11.5218 12.3578 10.499 12.357C9.47638 12.3581 8.49596 12.7648 7.77286 13.4879C7.04976 14.211 6.64306 15.1914 6.642 16.214C6.64279 17.2368 7.04938 18.2175 7.7725 18.9408C8.49563 19.6641 9.47621 20.071 10.499 20.072ZM37.499 20.072C38.522 20.0712 39.5028 19.6645 40.2261 18.9412C40.9495 18.2178 41.3562 17.237 41.357 16.214C41.3562 15.1911 40.9495 14.2102 40.2261 13.4869C39.5028 12.7635 38.522 12.3568 37.499 12.356C36.476 12.3568 35.4952 12.7635 34.7719 13.4869C34.0485 14.2102 33.6418 15.1911 33.641 16.214C33.6418 17.2375 34.0489 18.2188 34.7729 18.9422C35.4969 19.6657 36.4785 20.072 37.502 20.072H37.499ZM39.431 21.999H35.573C34.5543 21.998 33.5768 22.4011 32.855 23.12C34.0759 23.7845 35.1225 24.7282 35.9092 25.8742C36.696 27.0201 37.2006 28.3359 37.382 29.714H41.36C41.6134 29.7143 41.8643 29.6646 42.0985 29.5677C42.3327 29.4709 42.5454 29.3288 42.7246 29.1496C42.9038 28.9704 43.0458 28.7577 43.1427 28.5235C43.2395 28.2894 43.2893 28.0384 43.289 27.785V25.858C43.2885 24.8349 42.8819 23.8538 42.1585 23.1302C41.4351 22.4067 40.4541 21.9998 39.431 21.999V21.999ZM24.001 21.999C24.8877 21.9996 25.7658 21.8253 26.5851 21.4862C27.4044 21.1471 28.1489 20.6499 28.7759 20.0229C29.4028 19.3959 29.9001 18.6514 30.2392 17.8321C30.5783 17.0128 30.7525 16.1347 30.752 15.248C30.7523 14.3615 30.5778 13.4836 30.2386 12.6645C29.8994 11.8454 29.4021 11.1012 28.7751 10.4745C28.1482 9.84769 27.4038 9.35061 26.5847 9.01165C25.7655 8.67269 24.8875 8.4985 24.001 8.49902C23.1143 8.4985 22.2362 8.67276 21.4169 9.01184C20.5976 9.35093 19.8531 9.84818 19.2261 10.4752C18.5992 11.1022 18.1019 11.8466 17.7628 12.6659C17.4237 13.4852 17.2495 14.3633 17.25 15.25C17.2497 16.1366 17.4242 17.0145 17.7634 17.8335C18.1026 18.6526 18.5999 19.3968 19.2269 20.0236C19.8538 20.6504 20.5982 21.1474 21.4173 21.4864C22.2365 21.8254 23.1145 21.9996 24.001 21.999V21.999ZM28.63 23.929H28.13C26.8439 24.5575 25.4324 24.887 24.001 24.893C22.5697 24.8863 21.1583 24.5568 19.872 23.929H19.372C17.5304 23.9293 15.7643 24.661 14.4621 25.9632C13.1599 27.2654 12.4283 29.0314 12.428 30.873V32.609C12.4291 33.3757 12.7343 34.1106 13.2767 34.6525C13.8191 35.1943 14.5543 35.4988 15.321 35.499H32.68C33.4467 35.4988 34.1819 35.1943 34.7243 34.6525C35.2667 34.1106 35.5719 33.3757 35.573 32.609V30.873C35.5727 29.0316 34.8412 27.2657 33.5392 25.9635C32.2372 24.6614 30.4714 23.9296 28.63 23.929V23.929ZM15.146 23.122C14.4245 22.4024 13.447 21.9985 12.428 21.999H8.571C7.54786 21.9998 6.56688 22.4067 5.8435 23.1302C5.12013 23.8538 4.71353 24.8349 4.713 25.858V27.787C4.71274 28.0404 4.76245 28.2914 4.8593 28.5255C4.95615 28.7597 5.09823 28.9724 5.2774 29.1516C5.45658 29.3308 5.66934 29.4729 5.90349 29.5697C6.13765 29.6666 6.3886 29.7163 6.642 29.716H10.613C10.7967 28.3378 11.303 27.0225 12.0906 25.8767C12.8782 24.7309 13.9251 23.7872 15.146 23.122V23.122Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_36_286",
    x: -3.287,
    y: 0.499023,
    width: 54.576,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.370833 0 0 0 0 0.262035 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36_286"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36_286",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 41,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTotaluser);
export default __webpack_public_path__ + "static/media/ic_totaluser.92ccc188baca09615e72d47fda41f6a4.svg";
export { ForwardRef as ReactComponent };